import { Component, OnInit } from '@angular/core';
import {FormControl, FormArray, FormGroupDirective, NgForm, Validators, FormGroup, FormBuilder} from '@angular/forms';
import { SecondStageService } from '../../service/second-stage.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Observable, Subscription, timer } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ReturnStatement } from '@angular/compiler';
import {TranslateService} from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-candidate-application-form1',
    templateUrl: './candidate-application-form1.component.html'
})

export class CandidateApplicationForm1Component implements OnInit {
    activePage: any = '1';
    UpdateFormDisabled = false;
    employeeSecondForm: FormGroup;
    userToken: any;
    userId: string;
    userName: string;
    showHidePopup = false;
    private timer: Observable<any>;
    private subscription: Subscription;
    submitBtn = true;
    resubmitBtn = false;
    childrenAddMore = false;
    affiliationsAddMore = false;
    parentsAddMore = false;
    siblingsAddMore = false;
    relatedPersonsAddMore = false;
    currentLang = '';
    militaryServiceValidation = false;
    criminalConvictionValidation = false;
    drivingLicenseValidation = false;
    relatedPersonsValidation = false;
    relatedPersonValidation = false;
    maritalStatusValidation = false;
    marriedStatusValidation = false;
    childrenValidation = false;
    affiliationValidation = false;
    parentsValidation = false;
    siblingsValidation = false;
    childrenRadiobtnValidation = false;
    affiliationRadiobtnValidation = false;
    parentsRadiobtnValidation = false;
    siblingsRadiobtnValidation = false;
    updateId = '-2';
    updateDate: any;
    currentDate = new Date();
    minDate = new Date(1900, 0, 1);
    maxDate = new Date(2060, 0, 1);
    marriedForm = false;
    marriedChackbox = false;
    childrenChackbox = false;
    parentsChackbox = false;
    siblingsChackbox = false;
    showChildrenForm = false;
    showAffiliationForm = false;
    showParentsForm = false;
    showSiblingsForm = false;

    constructor(private secondStageService: SecondStageService,
                private fb: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                private http: HttpClient,
                public translateService: TranslateService,
                private titleService: Title) {
        this.route.params.subscribe(params => {
            if (params.token) {
                this.userToken = params.token;
                this.getCandidateByToken();
            } else {
                this.router.navigate(['/']);
            }
        });
    }

    formErrors = {};
    validationMessages = {
        passportNumber: {
            required: 'Passport number is required.',
        },
        IssuedByPassport: {
            required: 'Issued by is required.',
        },
        IssuedOnPassport: {
            required: 'Issued on is required.',
        },
        ssn: {
            required: 'Social security number is required.',
          minLength: 'Please enter 10 digits'
        },
        country: {
            required: 'Country is required.',
        },
        RegionCustomCandidate: {
            required: 'Region is required.',
        },
        CityNameCandidate: {
            required: 'City is required.',
        },
        address: {
            required: 'Address is required.',
        },
        maritalStatus: {
            required: 'Merital status is Required.',
        },
        ResidenceCountry: {
            required: 'Residence country is required.',
        },
        ResidenceRegion: {
            required: 'Residence region is required.',
        },
        ResidenceCity: {
            required: 'Residence city is required.',
        },
        ResidencyStreetaddress: {
            required: 'Residence address is required.',
        },
        MilitaryService: {
            required: 'Military service is required.',
        },
        YearsOfService: {
            required: 'Years of service are required.',
        },
        DrivingLicense: {
            required: 'Driving license year is required.',
        },
        CriminalConviction: {
            required: '',
        },
        Date: {
            required: 'Criminal conviction years are required.',
        },
        Place: {
            required: 'Criminal conviction place is required.',
        }
    };

    public getJSON(): Observable<any> {
        return this.http.get('/assets/country.json');
    }

    ngOnInit() {
        this.employeeSecondForm = this.fb.group({
            candidate: this.fb.group({
                passportNumber: ['', Validators.required],
                IssuedByPassport : ['', Validators.required],
                originalIssuedOnPassport: ['', Validators.required],
                issuedOnPassportViewValue: [''],
                IssuedOnPassport: [''],
                // ssn:  ['', [Validators.required, Validators.minLength(10),
                //   Validators.maxLength(10)]],
                ssn: ['', Validators.compose([
                  Validators.required,
                  Validators.minLength(10),
                ])],
                ssnCheckbox: [false],
                country: ['', Validators.required],
                RegionCustomCandidate: ['', Validators.required],
                CityNameCandidate: ['', Validators.required],
                address: ['', Validators.required],
                maritalStatus: ['', Validators.required],
                ResidenceCountry: ['', Validators.required],
                ResidenceRegion: ['', Validators.required],
                ResidenceCity: ['', Validators.required],
                ResidencyStreetaddress: ['', Validators.required],
                MilitaryService: ['', Validators.required],
                YearsOfService: [''],
                militaryServiceFromDate: [''],
                militaryServiceFromDateViewValue: [''],
                militaryServiceToDate: [''],
                militaryServiceToDateViewValue: [''],
                MilitaryService_Place : [''],
                DrivingLicense: ['', Validators.required],
                CriminalConviction: ['', Validators.required],
                Convictiondate: [''],
                convictionFromDate: [''],
                convictionFromDateViewValue: [''],
                convictionToDate: [''],
                convictionToDateViewValue: [''],
                Place: [''],
                relatedPersons: ['', Validators.required],
                FriendsAndRelatives: [''],
                husbandWifeFirstName: [''],
                husbandWifeLastName: [''],
                husbandWifeMiddleName: [''],
                husbandWifeCompany: [''],
                husbandWifePosition: [''],
                HusbandWife: [''],
                Children: ['', Validators.required],
                AffiliationLegalEntity: ['', Validators.required],
                Parents: ['', Validators.required],
                Siblings: ['', Validators.required],
                NameTypeLegalEntity: ['']
            }),
            children: this.fb.array([
                this.addChildrenFormGroup()
            ]),
            affiliations: this.fb.array([
                this.addAffiliationsFormGroup()
            ]),
            parents: this.fb.array([
                this.addParentsFormGroup()
            ]),
            siblings: this.fb.array([
                this.addSiblingsFormGroup()
            ]),
            relatedPersons: this.fb.array([
                this.addRelatedPersonFormGroup()
            ]),
            checkboxValidation: this.fb.group({
                registrationAddressCheckbox: [false],
            }),
            id: '',
            token: '',
        });
        this.getPageUpdateDate();

        this.translateService.get('form2BrowserName').subscribe(name => {
            this.titleService.setTitle(name);
        });
    }

    onClickMarriedStatus() {
        this.marriedForm = true;
        this.employeeSecondForm.get('candidate.husbandWifeFirstName').setValidators(Validators.required);
        this.employeeSecondForm.get('candidate.husbandWifeLastName').setValidators(Validators.required);
        this.employeeSecondForm.get('candidate.husbandWifeMiddleName').setValidators(Validators.required);
        this.employeeSecondForm.get('candidate.husbandWifeCompany').setValidators(Validators.required);
        this.employeeSecondForm.get('candidate.husbandWifePosition').setValidators(Validators.required);

        this.employeeSecondForm.get('candidate.husbandWifeFirstName').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifeLastName').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifeMiddleName').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifeCompany').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifePosition').updateValueAndValidity();
    }

    ifMarritalStatusMarried() {
        if (this.marriedForm) {
            this.employeeSecondForm.value.candidate.HusbandWife = this.employeeSecondForm.value.candidate.husbandWifeFirstName + ' ' +
                                                                  this.employeeSecondForm.value.candidate.husbandWifeLastName + ' ' +
                                                                  this.employeeSecondForm.value.candidate.husbandWifeMiddleName + ' (' +
                                                                  this.employeeSecondForm.value.candidate.husbandWifeCompany + ', ' +
                                                                  this.employeeSecondForm.value.candidate.husbandWifePosition + ')';
        }
    }

    onClickOtherStatuses() {
        this.marriedForm = false;
        this.employeeSecondForm.get('candidate.husbandWifeFirstName').clearValidators();
        this.employeeSecondForm.get('candidate.husbandWifeLastName').clearValidators();
        this.employeeSecondForm.get('candidate.husbandWifeMiddleName').clearValidators();
        this.employeeSecondForm.get('candidate.husbandWifeCompany').clearValidators();
        this.employeeSecondForm.get('candidate.husbandWifePosition').clearValidators();

        this.employeeSecondForm.get('candidate.husbandWifeFirstName').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifeLastName').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifeMiddleName').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifeCompany').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifePosition').updateValueAndValidity();
    }

    onChangeSsnCheckboxValue() {
        if (this.employeeSecondForm.get('candidate.ssnCheckbox').value) {
            this.employeeSecondForm.get('candidate.ssn').clearValidators();
            this.employeeSecondForm.get('candidate.ssn').reset('');
        } else {
            this.employeeSecondForm.get('candidate.ssn').setValidators(Validators.required);
        }
        this.employeeSecondForm.get('candidate.ssn').updateValueAndValidity();
    }

    onChangeMarriedChackboxValue(event) {
        if (event.checked) {
            this.marriedChackbox = true;
            this.employeeSecondForm.get('candidate.husbandWifeCompany').clearValidators();
            this.employeeSecondForm.get('candidate.husbandWifePosition').clearValidators();
        } else {
            this.marriedChackbox = false;
            this.employeeSecondForm.get('candidate.husbandWifeCompany').setValidators(Validators.required);
            this.employeeSecondForm.get('candidate.husbandWifePosition').setValidators(Validators.required);
            this.employeeSecondForm.get('candidate.husbandWifeCompany').reset('');
            this.employeeSecondForm.get('candidate.husbandWifePosition').reset('');
        }
        this.employeeSecondForm.get('candidate.husbandWifeCompany').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.husbandWifePosition').updateValueAndValidity();
    }

    onChangeChildrenChackboxValue(event) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.children.controls).forEach(control => {
            if (event.checked) {
                this.childrenChackbox = true;
                control.controls.placeOfWork.clearValidators();
                control.controls.position.clearValidators();
            } else {
                this.childrenChackbox = false;
                control.controls.placeOfWork.setValidators(Validators.required);
                control.controls.position.setValidators(Validators.required);
                control.controls.placeOfWork.reset('');
                control.controls.position.reset('');
            }
            control.controls.placeOfWork.updateValueAndValidity();
            control.controls.position.updateValueAndValidity();
        });
    }

    onChangeParentsChackboxValue(event) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.parents.controls).forEach(control => {
            if (event.checked) {
                this.parentsChackbox = true;
                control.controls.placeOfWork.clearValidators();
                control.controls.position.clearValidators();
            } else {
                this.parentsChackbox = false;
                control.controls.placeOfWork.setValidators(Validators.required);
                control.controls.position.setValidators(Validators.required);
                control.controls.placeOfWork.reset('');
                control.controls.position.reset('');
            }
            control.controls.placeOfWork.updateValueAndValidity();
            control.controls.position.updateValueAndValidity();
        });
    }

    onChangeSiblingsChackboxValue(event) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.siblings.controls).forEach(control => {
            if (event.checked) {
                this.siblingsChackbox = true;
                control.controls.placeOfWork.clearValidators();
                control.controls.position.clearValidators();
            } else {
                this.siblingsChackbox = false;
                control.controls.placeOfWork.setValidators(Validators.required);
                control.controls.position.setValidators(Validators.required);
                control.controls.placeOfWork.reset('');
                control.controls.position.reset('');
            }
            control.controls.placeOfWork.updateValueAndValidity();
            control.controls.position.updateValueAndValidity();
        });
    }

    onChangeMilitaryService(selectedValue: string) {
        if (selectedValue === 'yes') {
            this.employeeSecondForm.get('candidate.militaryServiceFromDate').setValidators(Validators.required);
            this.employeeSecondForm.get('candidate.militaryServiceToDate').setValidators(Validators.required);
            this.employeeSecondForm.get('candidate.MilitaryService_Place').setValidators(Validators.required);
        } else {
            this.employeeSecondForm.get('candidate.militaryServiceFromDate').clearValidators();
            this.employeeSecondForm.get('candidate.militaryServiceToDate').clearValidators();
            this.employeeSecondForm.get('candidate.MilitaryService_Place').clearValidators();
            this.employeeSecondForm.get('candidate.militaryServiceFromDate').reset('');
            this.employeeSecondForm.get('candidate.militaryServiceToDate').reset('');
            this.employeeSecondForm.get('candidate.MilitaryService_Place').reset('');
        }
        this.employeeSecondForm.get('candidate.militaryServiceFromDate').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.militaryServiceToDate').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.MilitaryService_Place').updateValueAndValidity();
    }

    onChangeConviction(selectedValue: string) {
        if (selectedValue === 'yes') {
            this.employeeSecondForm.get('candidate.convictionFromDate').setValidators(Validators.required);
            this.employeeSecondForm.get('candidate.convictionToDate').setValidators(Validators.required);
            this.employeeSecondForm.get('candidate.Place').setValidators(Validators.required);
        } else {
            this.employeeSecondForm.get('candidate.convictionFromDate').clearValidators();
            this.employeeSecondForm.get('candidate.convictionToDate').clearValidators();
            this.employeeSecondForm.get('candidate.Place').clearValidators();
            this.employeeSecondForm.get('candidate.convictionFromDate').reset('');
            this.employeeSecondForm.get('candidate.convictionToDate').reset('');
            this.employeeSecondForm.get('candidate.Place').reset('');
        }
        this.employeeSecondForm.get('candidate.convictionFromDate').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.convictionToDate').updateValueAndValidity();
        this.employeeSecondForm.get('candidate.Place').updateValueAndValidity();
    }

    onChangeRelatives(selectedValue: string) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.relatedPersons.controls).forEach(control => {
            if (selectedValue === 'yes') {
                control.controls.nameSurname.setValidators(Validators.required);
                control.controls.relationship.setValidators(Validators.required);
            } else {
                control.controls.nameSurname.clearValidators();
                control.controls.relationship.clearValidators();
                control.controls.nameSurname.reset('');
                control.controls.relationship.reset('');
            }
            control.controls.nameSurname.updateValueAndValidity();
            control.controls.relationship.updateValueAndValidity();
        });
    }

    onChangeChildren(selectedValue: string) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.children.controls).forEach(control => {
            if (selectedValue === 'yes') {
                this.showChildrenForm = true;
                control.controls.name.setValidators(Validators.required);
                control.controls.surname.setValidators(Validators.required);
                control.controls.middleName.setValidators(Validators.required);
                control.controls.placeOfWork.setValidators(Validators.required);
                control.controls.position.setValidators(Validators.required);
            } else {
                this.showChildrenForm = false;
                control.controls.name.clearValidators(Validators.required);
                control.controls.surname.clearValidators(Validators.required);
                control.controls.middleName.clearValidators(Validators.required);
                control.controls.placeOfWork.clearValidators(Validators.required);
                control.controls.position.clearValidators(Validators.required);

                control.controls.name.reset('');
                control.controls.surname.reset('');
                control.controls.middleName.reset('');
                control.controls.placeOfWork.reset('');
                control.controls.position.reset('');
            }
            control.controls.name.updateValueAndValidity(Validators.required);
            control.controls.surname.updateValueAndValidity(Validators.required);
            control.controls.middleName.updateValueAndValidity(Validators.required);
            control.controls.placeOfWork.updateValueAndValidity(Validators.required);
            control.controls.position.updateValueAndValidity(Validators.required);
        });
    }

  onChangeAffiliation(selectedValue: string) {
    // @ts-ignore
    (Object as any).values(this.employeeSecondForm.controls.affiliations.controls).forEach(control => {
      if (selectedValue === 'yes') {
        this.showAffiliationForm = true;
        control.controls.nameOfLegalEntity.setValidators(Validators.required);
        control.controls.typeOfAffiliation.setValidators(Validators.required);
      } else {
        this.showAffiliationForm = false;
        control.controls.nameOfLegalEntity.clearValidators(Validators.required);
        control.controls.typeOfAffiliation.clearValidators(Validators.required);

        control.controls.nameOfLegalEntity.reset('');
        control.controls.typeOfAffiliation.reset('');
      }
      control.controls.nameOfLegalEntity.updateValueAndValidity(Validators.required);
      control.controls.typeOfAffiliation.updateValueAndValidity(Validators.required);
    });
  }

    setChildren() {
        if (this.showChildrenForm) {
            const children = [] as string[];
            const childrenArray  =  [...this.employeeSecondForm.value.children];
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < childrenArray.length; i++) {
                // tslint:disable-next-line: max-line-length
                children.push(childrenArray[i].name + ' ' +  childrenArray[i].surname + ' ' + childrenArray[i].middleName + ' (' + childrenArray[i].placeOfWork +  ', ' +  childrenArray[i].position + ')');
            }
            this.employeeSecondForm.value.candidate = {...this.employeeSecondForm.value.candidate, Children: children.join(', ')};
        }
    }

  setAffiliations() {
    if (this.showAffiliationForm) {
      const affiliations = [] as string[];
      const affiliationsArray  =  [...this.employeeSecondForm.value.affiliations];
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < affiliationsArray.length; i++) {
        // tslint:disable-next-line: max-line-length
        affiliations.push(affiliationsArray[i].nameOfLegalEntity + '(' + affiliationsArray[i].typeOfAffiliation + ')');
      }
      this.employeeSecondForm.value.candidate = {...this.employeeSecondForm.value.candidate, NameTypeLegalEntity: affiliations.join(', '),
        AffiliationLegalEntity: 'Yes'};
    }
  }

    onChangeParents(selectedValue: string) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.parents.controls).forEach(control => {
            if (selectedValue === 'yes') {
                this.showParentsForm = true;
                control.controls.name.setValidators(Validators.required);
                control.controls.surname.setValidators(Validators.required);
                control.controls.middleName.setValidators(Validators.required);
                control.controls.placeOfWork.setValidators(Validators.required);
                control.controls.position.setValidators(Validators.required);
            } else {
                this.showParentsForm = false;
                control.controls.name.clearValidators(Validators.required);
                control.controls.surname.clearValidators(Validators.required);
                control.controls.middleName.clearValidators(Validators.required);
                control.controls.placeOfWork.clearValidators(Validators.required);
                control.controls.position.clearValidators(Validators.required);

                control.controls.name.reset('');
                control.controls.surname.reset('');
                control.controls.middleName.reset('');
                control.controls.placeOfWork.reset('');
                control.controls.position.reset('');
            }
            control.controls.name.updateValueAndValidity(Validators.required);
            control.controls.surname.updateValueAndValidity(Validators.required);
            control.controls.middleName.updateValueAndValidity(Validators.required);
            control.controls.placeOfWork.updateValueAndValidity(Validators.required);
            control.controls.position.updateValueAndValidity(Validators.required);
        });
    }

    setParents() {
        if (this.showParentsForm) {
            const parents = [] as string[];
            const parentsArray  =  [...this.employeeSecondForm.value.parents];
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < parentsArray.length; i++) {
                // tslint:disable-next-line: max-line-length
                parents.push(parentsArray[i].name + ' ' +  parentsArray[i].surname + ' ' + parentsArray[i].middleName + ' (' + parentsArray[i].placeOfWork +  ', ' +  parentsArray[i].position + ')');
            }
            this.employeeSecondForm.value.candidate = {...this.employeeSecondForm.value.candidate, Parents: parents.join(', ')};
        }
    }

    onChangeSiblings(selectedValue: string) {
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.siblings.controls).forEach(control => {
            if (selectedValue === 'yes') {
                this.showSiblingsForm = true;
                control.controls.name.setValidators(Validators.required);
                control.controls.surname.setValidators(Validators.required);
                control.controls.middleName.setValidators(Validators.required);
                control.controls.placeOfWork.setValidators(Validators.required);
                control.controls.position.setValidators(Validators.required);
            } else {
                this.showSiblingsForm = false;
                control.controls.name.clearValidators(Validators.required);
                control.controls.surname.clearValidators(Validators.required);
                control.controls.middleName.clearValidators(Validators.required);
                control.controls.placeOfWork.clearValidators(Validators.required);
                control.controls.position.clearValidators(Validators.required);

                control.controls.name.reset('');
                control.controls.surname.reset('');
                control.controls.middleName.reset('');
                control.controls.placeOfWork.reset('');
                control.controls.position.reset('');
            }
            control.controls.name.updateValueAndValidity(Validators.required);
            control.controls.surname.updateValueAndValidity(Validators.required);
            control.controls.middleName.updateValueAndValidity(Validators.required);
            control.controls.placeOfWork.updateValueAndValidity(Validators.required);
            control.controls.position.updateValueAndValidity(Validators.required);
        });
    }

    setSiblings() {
        if (this.showSiblingsForm) {
            const siblings = [] as string[];
            const siblingsArray  =  [...this.employeeSecondForm.value.siblings];
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < siblingsArray.length; i++) {
                // tslint:disable-next-line: max-line-length
                siblings.push(siblingsArray[i].name + ' ' +  siblingsArray[i].surname + ' ' + siblingsArray[i].middleName + ' (' + siblingsArray[i].placeOfWork +  ', ' +  siblingsArray[i].position + ')');
            }
            this.employeeSecondForm.value.candidate = {...this.employeeSecondForm.value.candidate, Siblings: siblings.join(', ')};
        }
    }

    updateCandidate() {
        const relatedPersons = [] as string[];
        const relatedPersonsArray  =  [...this.employeeSecondForm.value.relatedPersons];
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < relatedPersonsArray.length; i++) {
            relatedPersons.push(relatedPersonsArray[i].nameSurname + '(' + relatedPersonsArray[i].relationship + ')');
            }
        // @ts-ignore
        // tslint:disable-next-line: max-line-length
        this.employeeSecondForm.value.candidate = {...this.employeeSecondForm.value.candidate, FriendsAndRelatives: relatedPersons.join(', ')};
        this.employeeSecondForm.value.id = this.userId;
        if (this.employeeSecondForm.value.checkboxValidation.registrationAddressCheckbox) {
            this.employeeSecondForm.value.candidate.ResidenceCountry = this.employeeSecondForm.value.candidate.country;
            this.employeeSecondForm.value.candidate.ResidenceRegion = this.employeeSecondForm.value.candidate.RegionCustomCandidate;
            this.employeeSecondForm.value.candidate.ResidenceCity = this.employeeSecondForm.value.candidate.CityNameCandidate;
            this.employeeSecondForm.value.candidate.ResidencyStreetaddress = this.employeeSecondForm.value.candidate.address;
        }
        this.employeeSecondForm.value.token = this.userToken;

        const employeeFormStr = JSON.stringify(this.employeeSecondForm.value);
        this.secondStageService.updateCandidate(employeeFormStr).subscribe((result) => {
            if (result.Success) {
                this.router.navigate(['/success']);
            } else {
                this.setTimer();
                this.submitBtn = false;
                this.resubmitBtn = true;
            }
        });
    }

    public setTimer() {
        this.showHidePopup = true;
        this.timer = timer(3000);
        this.subscription = this.timer.subscribe(() => {
            this.showHidePopup = false;
        });
    }

  addAffiliationsFormGroup(): FormGroup {
        return this.fb.group({
          nameOfLegalEntity: [''],
          typeOfAffiliation: ['']
        });
    }

  addChildrenFormGroup(): FormGroup {
    return this.fb.group({
      name: [''],
      surname: [''],
      middleName: [''],
      placeOfWork: [''],
      position: ['']
    });
  }

    addChildrenButtonClick(): void {
        (this.employeeSecondForm.get('children') as FormArray).push(this.addChildrenFormGroup());
        this.childrenAddMore = true;
    }

  addAffiliationsButtonClick(): void {
    (this.employeeSecondForm.get('affiliations') as FormArray).push(this.addAffiliationsFormGroup());
    this.affiliationsAddMore = true;
  }

    removeChildrenButtonClick(childrenGroupIndex: number): void {
        (this.employeeSecondForm.get('children') as FormArray).removeAt(childrenGroupIndex);
        // @ts-ignore
        if (this.employeeForm.get('children').lenght > 1) {
                this.childrenAddMore = true;
        } else {
                this.childrenAddMore = false;
        }
    }

    removeAffiliationsButtonClick(affiliationsGroupIndex: number): void {
      (this.employeeSecondForm.get('affiliations') as FormArray).removeAt(affiliationsGroupIndex);
      // @ts-ignore
      if (this.employeeForm.get('affiliations').lenght > 1) {
        this.affiliationsAddMore = true;
      } else {
        this.affiliationsAddMore = false;
      }
    }

    addParentsFormGroup(): FormGroup {
        return this.fb.group({
            name: [''],
            surname: [''],
            middleName: [''],
            placeOfWork: [''],
            position: ['']
        });
    }

    addParentsButtonClick(): void {
        (this.employeeSecondForm.get('parents') as FormArray).push(this.addParentsFormGroup());
        this.parentsAddMore = true;
    }

    removeParentsButtonClick(parentsGroupIndex: number): void {
        (this.employeeSecondForm.get('parents') as FormArray).removeAt(parentsGroupIndex);
        // @ts-ignore
        if (this.employeeForm.get('parents').lenght > 1) {
                this.parentsAddMore = true;
        } else {
                this.parentsAddMore = false;
        }
    }

    addSiblingsFormGroup(): FormGroup {
        return this.fb.group({
            name: [''],
            surname: [''],
            middleName: [''],
            placeOfWork: [''],
            position: ['']
        });
    }

    addSiblingsButtonClick(): void {
        (this.employeeSecondForm.get('siblings') as FormArray).push(this.addSiblingsFormGroup());
        this.siblingsAddMore = true;
    }

    removeSiblingsButtonClick(siblingsGroupIndex: number): void {
        (this.employeeSecondForm.get('siblings') as FormArray).removeAt(siblingsGroupIndex);
        // @ts-ignore
        if (this.employeeForm.get('siblings').lenght > 1) {
                this.siblingsAddMore = true;
        } else {
                this.siblingsAddMore = false;
        }
    }

    addRelatedPersonFormGroup(): FormGroup {
        return this.fb.group({
            nameSurname: [''],
            relationship: ['']
        });
    }

    addRelatedPersonButtonClick(): void {
        (this.employeeSecondForm.get('relatedPersons') as FormArray).push(this.addRelatedPersonFormGroup());
        this.relatedPersonsAddMore = true;
    }

    removeRelatedPersonButtonClick(relatedPersonGroupIndex: number): void {
        (this.employeeSecondForm.get('relatedPersons') as FormArray).removeAt(relatedPersonGroupIndex);
        // @ts-ignore
        if (this.employeeForm.get('relatedPersons').lenght > 1) {
                this.relatedPersonsAddMore = true;
        } else {
                this.relatedPersonsAddMore = false;
        }
    }

    getCandidateByToken() {
        const token = this.userToken;
        this.secondStageService.getCandidateByTokene(token).
        subscribe((result) => {
            if (result) {
                // @ts-ignore
                this.userId = result.Data.Id;
                // @ts-ignore
                this.userName = result.Data.Name;
            }
            }
        );
    }

scrollTop() {
    if (window.scrollY) {
        window.scroll(0, 0);
    }
}

back() {
    this.scrollTop();
    this.activePage = this.activePage - 1;
}

onClickReview() {
    this.activePage = 5;
    this.setChildren();
    this.setAffiliations();
    this.setParents();
    this.setSiblings();
    this.getFormatedDates();
    this.ifMarritalStatusMarried();
}



firstStepValidation() {
    if (
            this.employeeSecondForm.get('candidate.passportNumber').invalid ||
            this.employeeSecondForm.get('candidate.IssuedByPassport').invalid ||
            this.employeeSecondForm.get('candidate.originalIssuedOnPassport').invalid ||
            this.employeeSecondForm.get('candidate.ssn').invalid
    ) {
            this.employeeSecondForm.get('candidate.passportNumber').markAsTouched();
            this.employeeSecondForm.get('candidate.IssuedByPassport').markAsTouched();
            this.employeeSecondForm.get('candidate.originalIssuedOnPassport').markAsTouched();
            this.employeeSecondForm.get('candidate.ssn').markAsTouched();
    } else {
            this.activePage = 2;
    }
    this.scrollTop();
}

secondStepValidation() {
    if (this.employeeSecondForm.value.checkboxValidation.registrationAddressCheckbox) {
        if (
            this.employeeSecondForm.get('candidate.country').invalid ||
            this.employeeSecondForm.get('candidate.RegionCustomCandidate').invalid ||
            this.employeeSecondForm.get('candidate.CityNameCandidate').invalid ||
            this.employeeSecondForm.get('candidate.address').invalid
        ) {
            this.employeeSecondForm.get('candidate.country').markAsTouched();
            this.employeeSecondForm.get('candidate.RegionCustomCandidate').markAsTouched();
            this.employeeSecondForm.get('candidate.CityNameCandidate').markAsTouched();
            this.employeeSecondForm.get('candidate.address').markAsTouched();
        } else {
                this.activePage = 3;
        }
    } else if (!this.employeeSecondForm.value.checkboxValidation.registrationAddressCheckbox) {
        if (
            this.employeeSecondForm.get('candidate.country').invalid ||
            this.employeeSecondForm.get('candidate.RegionCustomCandidate').invalid ||
            this.employeeSecondForm.get('candidate.CityNameCandidate').invalid ||
            this.employeeSecondForm.get('candidate.address').invalid ||
            this.employeeSecondForm.get('candidate.ResidenceCountry').invalid ||
            this.employeeSecondForm.get('candidate.ResidenceRegion').invalid ||
            this.employeeSecondForm.get('candidate.ResidenceCity').invalid ||
            this.employeeSecondForm.get('candidate.ResidencyStreetaddress').invalid
        ) {
            this.employeeSecondForm.get('candidate.country').markAsTouched();
            this.employeeSecondForm.get('candidate.RegionCustomCandidate').markAsTouched();
            this.employeeSecondForm.get('candidate.CityNameCandidate').markAsTouched();
            this.employeeSecondForm.get('candidate.address').markAsTouched();
            this.employeeSecondForm.get('candidate.ResidenceCountry').markAsTouched();
            this.employeeSecondForm.get('candidate.ResidenceRegion').markAsTouched();
            this.employeeSecondForm.get('candidate.ResidenceCity').markAsTouched();
            this.employeeSecondForm.get('candidate.ResidencyStreetaddress').markAsTouched();
        } else {
            this.activePage = 3;
        }
    }
    this.scrollTop();
}



thirdStepValidation() {
    if (this.employeeSecondForm.get('candidate.relatedPersons').invalid) {
        this.employeeSecondForm.get('candidate.relatedPersons').markAsTouched();
        this.relatedPersonValidation = false;
    } else {
        this.relatedPersonValidation = true;
    }
    if (this.employeeSecondForm.get('candidate.husbandWifeFirstName').invalid ||
        this.employeeSecondForm.get('candidate.husbandWifeLastName').invalid ||
        this.employeeSecondForm.get('candidate.husbandWifeMiddleName').invalid ||
        this.employeeSecondForm.get('candidate.husbandWifeCompany').invalid ||
        this.employeeSecondForm.get('candidate.husbandWifePosition').invalid) {

        this.employeeSecondForm.get('candidate.husbandWifeFirstName').markAsTouched();
        this.employeeSecondForm.get('candidate.husbandWifeLastName').markAsTouched();
        this.employeeSecondForm.get('candidate.husbandWifeMiddleName').markAsTouched();
        this.employeeSecondForm.get('candidate.husbandWifeCompany').markAsTouched();
        this.employeeSecondForm.get('candidate.husbandWifePosition').markAsTouched();

        this.marriedStatusValidation = false;
    } else {
        this.marriedStatusValidation = true;
    }
    if (this.employeeSecondForm.get('candidate.Children').invalid) {
        this.employeeSecondForm.get('candidate.Children').markAsTouched();
    } else {
        this.childrenRadiobtnValidation = true;
    }
    if (this.employeeSecondForm.get('children').invalid) {
        this.childrenValidation = false;
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.children.controls).forEach(control => {
            control.controls.name.markAsTouched();
            control.controls.surname.markAsTouched();
            control.controls.middleName.markAsTouched();
            control.controls.placeOfWork.markAsTouched();
            control.controls.position.markAsTouched();
        });
    } else {
        this.childrenValidation = true;
    }

    if (this.employeeSecondForm.get('candidate.Parents').invalid) {
        this.employeeSecondForm.get('candidate.Parents').markAsTouched();
    } else {
        this.parentsRadiobtnValidation = true;
    }
    if (this.employeeSecondForm.get('parents').invalid) {
        this.parentsValidation = false;
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.parents.controls).forEach(control => {
            control.controls.name.markAsTouched();
            control.controls.surname.markAsTouched();
            control.controls.middleName.markAsTouched();
            control.controls.placeOfWork.markAsTouched();
            control.controls.position.markAsTouched();
        });
    } else {
        this.parentsValidation = true;
    }

    if (this.employeeSecondForm.get('candidate.Siblings').invalid) {
        this.employeeSecondForm.get('candidate.Siblings').markAsTouched();
    } else {
        this.siblingsRadiobtnValidation = true;
    }
    if (this.employeeSecondForm.get('siblings').invalid) {
        this.siblingsValidation = false;
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.siblings.controls).forEach(control => {
            control.controls.name.markAsTouched();
            control.controls.surname.markAsTouched();
            control.controls.middleName.markAsTouched();
            control.controls.placeOfWork.markAsTouched();
            control.controls.position.markAsTouched();
        });
    } else {
        this.siblingsValidation = true;
    }

    if (this.employeeSecondForm.get('relatedPersons').invalid) {
        this.relatedPersonsValidation = false;
        // @ts-ignore
        (Object as any).values(this.employeeSecondForm.controls.relatedPersons.controls).forEach(control => {
            control.controls.nameSurname.markAsTouched();
            control.controls.relationship.markAsTouched();
        });
    } else {
        this.relatedPersonsValidation = true;
    }
    if (this.employeeSecondForm.get('candidate.maritalStatus').invalid) {
        this.employeeSecondForm.get('candidate.maritalStatus').markAsTouched();
    } else {
        this.maritalStatusValidation = true;
    }
    // tslint:disable-next-line: max-line-length
    if (this.marriedStatusValidation && this.maritalStatusValidation && this.childrenValidation && this.childrenRadiobtnValidation  && this.parentsRadiobtnValidation && this.parentsValidation && this.siblingsRadiobtnValidation && this.siblingsValidation && this.relatedPersonsValidation && this.relatedPersonValidation) {
        this.activePage = 4;
    }
    this.setChildren();
    this.setParents();
    this.setSiblings();
    this.scrollTop();
    this.ifMarritalStatusMarried();
}

forthStepValidation() {
    if (this.employeeSecondForm.get('candidate.MilitaryService').invalid) {
        this.employeeSecondForm.get('candidate.MilitaryService').markAsTouched();
    }
    // tslint:disable-next-line: max-line-length
    if (this.employeeSecondForm.get('candidate.militaryServiceFromDate').invalid || this.employeeSecondForm.get('candidate.militaryServiceToDate').invalid || this.employeeSecondForm.get('candidate.MilitaryService_Place').invalid) {
        this.militaryServiceValidation = false;
        this.employeeSecondForm.get('candidate.militaryServiceFromDate').markAsTouched();
        this.employeeSecondForm.get('candidate.militaryServiceToDate').markAsTouched();
        this.employeeSecondForm.get('candidate.MilitaryService_Place').markAsTouched();
    } else {
        this.militaryServiceValidation = true;
    }
    if (this.employeeSecondForm.get('candidate.CriminalConviction').invalid) {
        this.employeeSecondForm.get('candidate.CriminalConviction').markAsTouched();
    }
    // tslint:disable-next-line: max-line-length
    if (this.employeeSecondForm.get('candidate.convictionFromDate').invalid || this.employeeSecondForm.get('candidate.convictionToDate').invalid || this.employeeSecondForm.get('candidate.Place').invalid) {
        this.criminalConvictionValidation = false;
        this.employeeSecondForm.get('candidate.convictionFromDate').markAsTouched();
        this.employeeSecondForm.get('candidate.convictionToDate').markAsTouched();
        this.employeeSecondForm.get('candidate.Place').markAsTouched();
    } else {
        this.criminalConvictionValidation = true;
    }
    if (this.employeeSecondForm.get('candidate.DrivingLicense').invalid) {
        this.employeeSecondForm.get('candidate.DrivingLicense').markAsTouched();
    } else {
        this.drivingLicenseValidation = true;
    }

    if (this.employeeSecondForm.get('candidate.AffiliationLegalEntity').invalid) {
      this.affiliationRadiobtnValidation = false;
      this.employeeSecondForm.get('candidate.AffiliationLegalEntity').markAsTouched();
    } else {
      this.affiliationRadiobtnValidation = true;
    }
    if (this.employeeSecondForm.get('affiliations').invalid) {
      this.affiliationValidation = false;
      // @ts-ignore
      (Object as any).values(this.employeeSecondForm.controls.affiliations.controls).forEach(control => {
        control.controls.nameOfLegalEntity.markAsTouched();
        control.controls.typeOfAffiliation.markAsTouched();
      });
    } else {
      this.affiliationValidation = true;
    }

    if (this.militaryServiceValidation && this.criminalConvictionValidation && this.drivingLicenseValidation && this.affiliationValidation && this.affiliationRadiobtnValidation) {
        this.activePage = 5;
    }
    this.scrollTop();
    this.getFormatedDates();
    this.setChildren();
    this.setAffiliations();
    this.setParents();
    this.setSiblings();
    this.ifMarritalStatusMarried()
}

getPageUpdateDate() {
    this.secondStageService.getPageUpdateDate(this.updateId).subscribe((result) => {
      if (result) {
        const originalDate = result;
        // @ts-ignore
        const originalDateSplit = originalDate.split('T');
        const originalDay = originalDateSplit[0].split('-');
        const originalHours = originalDateSplit[1].split(':');
        const dayToView = originalDay[2] + '/' + originalDay[1] + '/' + originalDay[0];
        const hoursToview = originalHours[0] + ':' + originalHours[1];
        this.updateDate = dayToView + ',' + ' ' + hoursToview;
      }
    });
}

formatFullDate(fullDate): any {
    // tslint:disable-next-line: max-line-length
    return `${Number(fullDate.getDate()) < 10 ? 0 : ''}${fullDate.getDate()}/${Number(fullDate.getMonth() + 1) < 10 ? 0 : ''}${fullDate.getMonth() + 1}/${fullDate.getFullYear()}`;
}

checkIsValidDate(date) {
    return `${date.getFullYear()}`;
}

getFormatedDates() {
    // tslint:disable-next-line: max-line-length
    const hasValideMilitaryServiceFromDate = !!this.employeeSecondForm.value.candidate.militaryServiceFromDate ? this.checkIsValidDate(this.employeeSecondForm.value.candidate.militaryServiceFromDate) : null;
    if (hasValideMilitaryServiceFromDate) {
        // tslint:disable-next-line: max-line-length
        const militaryServiceFromDateSplit = this.formatFullDate(this.employeeSecondForm.value.candidate.militaryServiceFromDate).split('/');
        // tslint:disable-next-line: max-line-length
        this.employeeSecondForm.value.candidate.militaryServiceFromDateViewValue = militaryServiceFromDateSplit[0] + '/' + militaryServiceFromDateSplit[1] + '/' + militaryServiceFromDateSplit[2];
    }
    // tslint:disable-next-line: max-line-length
    const hasValideMilitaryServiceToDate = !!this.employeeSecondForm.value.candidate.militaryServiceToDate ? this.checkIsValidDate(this.employeeSecondForm.value.candidate.militaryServiceToDate) : null;
    if (hasValideMilitaryServiceToDate) {
        const militaryServiceToDateSplit = this.formatFullDate(this.employeeSecondForm.value.candidate.militaryServiceToDate).split('/');
        // tslint:disable-next-line: max-line-length
        this.employeeSecondForm.value.candidate.militaryServiceToDateViewValue = militaryServiceToDateSplit[0] + '/' + militaryServiceToDateSplit[1] + '/' + militaryServiceToDateSplit[2];
    }

    // tslint:disable-next-line: max-line-length
    this.employeeSecondForm.value.candidate.YearsOfService = this.employeeSecondForm.value.candidate.militaryServiceFromDateViewValue + ' - ' + this.employeeSecondForm.value.candidate.militaryServiceToDateViewValue;





    // tslint:disable-next-line: max-line-length
    const hasValideMilitaryconvictionFromDate = !!this.employeeSecondForm.value.candidate.convictionFromDate ? this.checkIsValidDate(this.employeeSecondForm.value.candidate.convictionFromDate) : null;
    if (hasValideMilitaryconvictionFromDate) {
        // tslint:disable-next-line: max-line-length
        const convictionFromDateSplit = this.formatFullDate(this.employeeSecondForm.value.candidate.convictionFromDate).split('/');
        // tslint:disable-next-line: max-line-length
        this.employeeSecondForm.value.candidate.convictionFromDateViewValue = convictionFromDateSplit[0] + '/' + convictionFromDateSplit[1] + '/' + convictionFromDateSplit[2];
    }
    // tslint:disable-next-line: max-line-length
    const hasValideMilitaryConvictionToDate = !!this.employeeSecondForm.value.candidate.convictionToDate ? this.checkIsValidDate(this.employeeSecondForm.value.candidate.convictionToDate) : null;
    if (hasValideMilitaryConvictionToDate) {
        // tslint:disable-next-line: max-line-length
        const convictionToDateSplit = this.formatFullDate(this.employeeSecondForm.value.candidate.convictionToDate).split('/');
        // tslint:disable-next-line: max-line-length
        this.employeeSecondForm.value.candidate.convictionToDateViewValue = convictionToDateSplit[0] + '/' + convictionToDateSplit[1] + '/' + convictionToDateSplit[2];
    }

    // tslint:disable-next-line: max-line-length
    this.employeeSecondForm.value.candidate.Convictiondate = this.employeeSecondForm.value.candidate.convictionFromDateViewValue + ' - ' + this.employeeSecondForm.value.candidate.convictionToDateViewValue;





    // tslint:disable-next-line: max-line-length
    const hasValideIssuedOnDate = !!this.employeeSecondForm.value.candidate.originalIssuedOnPassport ? this.checkIsValidDate(this.employeeSecondForm.value.candidate.originalIssuedOnPassport) : null;
    if (hasValideIssuedOnDate) {
        const originalIssuedOnDateSplit = this.formatFullDate(this.employeeSecondForm.value.candidate.originalIssuedOnPassport).split('/');
        // tslint:disable-next-line: max-line-length
        this.employeeSecondForm.value.candidate.issuedOnPassportViewValue = originalIssuedOnDateSplit[0] + '/' + originalIssuedOnDateSplit[1] + '/' + originalIssuedOnDateSplit[2];
    }

    // tslint:disable-next-line: max-line-length
    this.employeeSecondForm.value.candidate.IssuedOnPassport = this.employeeSecondForm.value.candidate.issuedOnPassportViewValue;
}



onSubmit() {
    this.setChildren();
    this.setParents();
    this.setSiblings();
    // @ts-ignore
    //console.log(this.employeeSecondForm.value);

}

}
